import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as Parse from 'parse';

@Injectable()
export class EstatedService {
    // API_URL = 'https://apis.estated.com/v4/property?token=' + environment.estatedAPIKey;
    API_URL = 'https://api.gateway.attomdata.com/propertyapi/v1.0.0/';

    constructor(private http: HttpClient) {
    }

    /**
     * Resolves to a result object with the estated data.
     * See: https://estated.com/developers/docs/v4/property/overview#response
     * @param property The Property Parse Object.
     */
    public async getPropertyInfo(property: Parse.Object) {
        let url = this.API_URL;

        // url += '&street_address=' + encodeURIComponent(property.get('address') + (property.get('address2') ? (' ' + property.get('address2')) : ''));
        // url += '&city=' + encodeURIComponent(property.get('city'));
        // url += '&state=' + encodeURIComponent(property.get('state'));
        // url += '&zip_code=' + encodeURIComponent(property.get('zip'));
        url += 'property/expandedprofile?address1=' + encodeURIComponent(property.get('address'));
        url += '&address2=' + encodeURIComponent(property.get('address2'));

        let result = await this.requestPropertyInfo(url);
        console.log(result);

        if (!(result as any).data) {
            // Attempt to load without north/south indicator.
            url = url.replace('north', '');
            url = url.replace('south', '');
            result = await this.requestPropertyInfo(url);
        }

        return result;
    }

    requestPropertyInfo(url: string) {
        const headers = new HttpHeaders({
            apikey: environment.estatedAPIKey,
            accept: 'application/json'
        });

        return this.http.get(url, { headers: headers }).toPromise();
    }
}
